


document.addEventListener("DOMContentLoaded",function(){
	
	if (jQuery('#google-map').length > 0) {
		console.log('DOM READY');
		// initGoogleMap();
	}
});

function initGoogleMap() {
	// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
	var mapOptions = {
		zoom: 16,
		disableDefaultUI: true,
		//59.925626!4d10.792086
		center: new google.maps.LatLng(59.9440429, 10.8605944), // The latitude and longitude to center the map (always required)
		// Custom styles - Snazzy maps
		// https://snazzymaps.com/style/134/light-dream
		styles: [{"featureType":"landscape","stylers":[{"hue":"#FFBB00"},{"saturation":83.400000000000006},{"lightness":37.599999999999994},{"gamma":1}]},{"featureType":"road.highway","stylers":[{"hue":"#FFC200"},{"saturation":-61.8},{"lightness":45.599999999999994},{"gamma":1}]},{"featureType":"road.arterial","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":51.19999999999999},{"gamma":1}]},{"featureType":"road.local","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":52},{"gamma":1}]},{"featureType":"water","stylers":[{"hue":"#0078FF"},{"saturation":-13.200000000000003},{"lightness":2.4000000000000057},{"gamma":1}]},{"featureType":"poi","stylers":[{"hue":"#b3def6"},{"saturation":-1.0989010989011234},{"lightness":11.200000000000017},{"gamma":1}]}]
	};
	var mapElement = document.getElementById('map');

	// Create the Google Map using our element and options defined above
	var map = new google.maps.Map(mapElement, mapOptions);

	// Let's also add a marker while we're at it
	var marker = new google.maps.Marker({
		position: new google.maps.LatLng(59.9440429, 10.8605944),
		// position: new google.maps.LatLng(59.925626, 10.792086),
		map: map,
		title: 'Sven Oftedals vei 1'
		// title: 'Haslevollen 3, inngang B'
		//icon: siteUrlImages + '/icon-pin.png'
	});

	function toggleBounce() {
		if (marker.getAnimation() !== null) {
			marker.setAnimation(null);
		} else {
			marker.setAnimation(google.maps.Animation.BOUNCE);
		}
	}

	marker.setMap(map);
	marker.addListener('click', toggleBounce);

}



      
      


    